import axios from "axios"
import axiosInstance from "../utils/axios"

export const mapsService = {
  getAddressByQuery: async (params = {}) => {
    const response = await axiosInstance.get('/external-service/map', {
      params,
    })
    return response.data
  },
  searchAddress: async address => {
    const { data } = await axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=5`)
    return data
  },
  reverseGeocode: async (lat, lng) => {
    const { data } = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`)
    return data
  }
}